export default __webpack_public_path__ + "static/media/cancel.55ad1c34.svg";